var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-flex uk-flex-column internet-page"},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-flex uk-flex-row internet-menu"},[_c('div',{staticClass:"uk-flex uk-flex-row flat"})])
}]

export { render, staticRenderFns }